import { Component, Input } from '@angular/core';
import {
  Navigation,
  Property,
  SectionConfig,
  TargetType,
} from '../../../dto/response/template.config';
import { TemplateConfigService } from '../../../service/template-config.service';
import { NgClass } from '@angular/common';
import { MenuService } from '../../../service/menu.service';
import {Router, RouterLink, RouterLinkActive} from '@angular/router';
import { NavigationService } from '../../../service/navigation.service';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [NgClass, RouterLinkActive, RouterLink, TranslateModule],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
})
export class MenuComponent {
  @Input() class: string;
  menu?: Property;
  protected readonly TargetType = TargetType;

  constructor(
    private router: Router,
    private templateConfigService: TemplateConfigService,
    public menuService: MenuService,
    public navigationService: NavigationService,
  ) {}

  _config: SectionConfig;

  @Input()
  set config(config: SectionConfig) {
    this._config = config;
    this.menu = this.templateConfigService.findConfig(config, 'menu');
    console.log(this.menu);
  }

  mainMenuClose() {
    this.menuService.mainMenuToggle = false;
  }

  redirect(navigation: Navigation) {
    this.navigationService.navigateTo(navigation);
  }
}
